import React from 'react';
import { useParams } from 'react-router-dom';

import { EmprestimoUniformeLista } from 'Component/EmprestimoUniforme';
import { useRecuperarEmprestimosUniformeQuery } from 'View/Service/Default/EmprestimosUniforme';

const Uniformes = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const { data: { emprestimos } = {} } = useRecuperarEmprestimosUniformeQuery({
    contain: ['VinculosEmpregaticios.Usuarios', 'Uniformes'],
    options: { usuario_id: id },
    sort: 'nome',
  });

  return (
    <React.Fragment>
      <div className="bg-white shadow-sm rounded">
        {emprestimos?.map((emprestimo) => (
          <EmprestimoUniformeLista
            dados={emprestimo}
            key={`${emprestimo.id}-${emprestimo.modificado}`}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default Uniformes;
